var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 50,
    d: "M80.999 47.5273C97.0434 47.5273 110.072 60.7102 110.072 77C110.072 93.2898 97.0434 106.473 80.999 106.473C64.9547 106.473 51.9258 93.2898 51.9258 77C51.9258 60.7103 64.9547 47.5274 80.999 47.5273Z",
    fill: "url(#paint0_linear_668_7262)",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_668_7262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9992 107.473C97.6082 107.473 111.073 93.8297 111.073 77.0001C111.073 60.1704 97.6082 46.5273 80.9992 46.5273C64.3901 46.5273 50.9258 60.1704 50.9258 77.0001C50.9258 93.8297 64.3901 107.473 80.9992 107.473Z",
    fill: "url(#paint1_linear_668_7262)",
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1429 99.6702C110.603 91.7556 124.354 75.1901 119.857 62.6702C115.36 50.1503 94.3174 46.4169 72.8571 54.3315C51.3969 62.2461 37.6457 78.8115 42.1429 91.3315C46.64 103.851 67.6826 107.585 89.1429 99.6702Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9178 91.5902C83.2315 103.76 100.244 107.094 106.917 99.0365C113.589 90.9789 107.395 74.581 93.0813 62.4109C78.7676 50.2408 61.7549 46.907 55.0823 54.9647C48.4097 63.0223 54.6041 79.4201 68.9178 91.5902Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.017 79.2858C119.263 79.2858 120.273 78.2625 120.273 77.0003C120.273 75.7381 119.263 74.7148 118.017 74.7148C116.772 74.7148 115.762 75.7381 115.762 77.0003C115.762 78.2625 116.772 79.2858 118.017 79.2858Z",
    fill: "url(#paint2_linear_668_7262)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.419 90.4595C49.5262 90.4595 50.4238 89.55 50.4238 88.428C50.4238 87.306 49.5262 86.3965 48.419 86.3965C47.3117 86.3965 46.4141 87.306 46.4141 88.428C46.4141 89.55 47.3117 90.4595 48.419 90.4595Z",
    fill: "url(#paint3_linear_668_7262)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.56 102.829C106.667 102.829 107.564 101.919 107.564 100.797C107.564 99.6752 106.667 98.7656 105.56 98.7656C104.452 98.7656 103.555 99.6752 103.555 100.797C103.555 101.919 104.452 102.829 105.56 102.829Z",
    fill: "url(#paint4_linear_668_7262)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9195 100.944C93.4025 100.944 94.6046 99.7254 94.6046 98.2227C94.6046 96.7201 93.4025 95.502 91.9195 95.502C90.4365 95.502 89.2344 96.7201 89.2344 98.2227C89.2344 99.7254 90.4365 100.944 91.9195 100.944Z",
    fill: "url(#paint5_linear_668_7262)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.283 56.3223C111.261 56.3223 112.863 54.7794 112.863 52.876C112.863 50.9727 111.261 49.4297 109.283 49.4297C107.306 49.4297 105.703 50.9727 105.703 52.876C105.703 54.7794 107.306 56.3223 109.283 56.3223Z",
    fill: "url(#paint6_linear_668_7262)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4467 106.521C60.5228 106.521 62.2058 104.815 62.2058 102.711C62.2058 100.608 60.5228 98.9023 58.4467 98.9023C56.3705 98.9023 54.6875 100.608 54.6875 102.711C54.6875 104.815 56.3705 106.521 58.4467 106.521Z",
    fill: "url(#paint7_linear_668_7262)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_668_7262_clip_path",
    transform: "translate(49.0742 53.4727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.999 47.5273C97.0434 47.5273 110.072 60.7102 110.072 77C110.072 93.2898 97.0434 106.473 80.999 106.473C64.9547 106.473 51.9258 93.2898 51.9258 77C51.9258 60.7103 64.9547 47.5274 80.999 47.5273Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_668_7262",
    x: 0.925781,
    y: 0.527344,
    width: 160.148,
    height: 160.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.556863 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_668_7262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_668_7262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_7262",
    x1: 76.1122,
    y1: 107.473,
    x2: 99.6721,
    y2: 57.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0950DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239553,
    stopColor: "#223CCE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469725,
    stopColor: "#7D5AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684586,
    stopColor: "#BC5596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860234,
    stopColor: "#EA5684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_7262",
    x1: 76.1122,
    y1: 107.473,
    x2: 99.6721,
    y2: 57.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0950DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239553,
    stopColor: "#223CCE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469725,
    stopColor: "#7D5AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684586,
    stopColor: "#BC5596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860234,
    stopColor: "#EA5684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_7262",
    x1: 118.017,
    y1: 74.7148,
    x2: 118.017,
    y2: 79.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_7262",
    x1: 48.419,
    y1: 86.3965,
    x2: 48.419,
    y2: 90.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#228B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_668_7262",
    x1: 105.56,
    y1: 98.7656,
    x2: 105.56,
    y2: 102.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_668_7262",
    x1: 91.9195,
    y1: 95.502,
    x2: 91.9195,
    y2: 100.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_668_7262",
    x1: 109.283,
    y1: 49.4297,
    x2: 109.283,
    y2: 56.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_668_7262",
    x1: 58.4467,
    y1: 98.9023,
    x2: 58.4467,
    y2: 106.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.80f741c7f2fc94e1ca280bc588862d13.svg";
export { ForwardRef as ReactComponent };